interface IRadioButtonProps {
  htmlFor: string;
  handleSelect: (value: string | number) => void;
  id: string;
  labelTitle: string;
  idx: number;
  value: string | number;
  labelClassName?: string;
  name?: string;
  defaultValue?: string | number;
  checked?: boolean;
  disabled?: boolean;
}

const RadioButton: React.FC<IRadioButtonProps> = ({
  htmlFor,
  handleSelect,
  id,
  labelTitle,
  idx,
  value,
  labelClassName,
  name = '',
  checked = false,
  disabled = false
}) => {
  return (
    <>
      <input
        onChange={() => handleSelect(value)}
        onClick={() => handleSelect(value)}
        className="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-tt-yellow checked:border-tt-dark-purple focus:ring-tt-dark-purple focus:ring-[0.5px] focus:ring-offset-0 transition duration-200 mt-1 align-top float-left mr-2 cursor-pointer"
        type="radio"
        name={name}
        id={id}
        disabled={disabled}
        value={value}
        checked={checked}
      />
      <label
        className={`cursor-pointer form-check-label inline-block ${
          labelClassName || 'text-tt-light-gray-purple'
        }`}
        htmlFor={htmlFor}>
        {labelTitle}
      </label>
    </>
  );
};

export default RadioButton;
